import * as React from "react";
import styled from "styled-components";
import { HTMLRenderer } from "../../../../../../course-author/html-editor/Renderer";
import {
  HintContainer,
  Label,
  LabelsContainer,
} from "../../../../../../course-author/instruction/parts/exercises/common.styles";
import { IClozeGapLocalized, ICourseLocalizedText } from "../../../../../../course-author/types";

export interface IGapHintProps {
  hint: ICourseLocalizedText;
}

export const GapHint: React.FC<IGapHintProps> = props => {
  return <HintContainer>{props.hint.value.text}</HintContainer>;
};

const PreviewContainer = styled.div`
  margin: 0 1rem;
  min-width: 1rem;
`;

export interface IGapPreviewProps {
  gap: IClozeGapLocalized;
}

const GapPreview: React.FC<IGapPreviewProps> = ({ gap }) => {
  return (
    <PreviewContainer>
      <HintContainer>
        <HTMLRenderer source={gap && gap.hint && gap.hint.map(hint => hint.value.text).join("")} />
      </HintContainer>
      <LabelsContainer>
        {gap &&
          gap.answers &&
          gap.answers.map(answer =>
            answer.value.value.map((option, i) => (
              <Label isEditing={false} key={i}>
                {option}
              </Label>
            ))
          )}
      </LabelsContainer>
    </PreviewContainer>
  );
};

export default GapPreview;
